// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".alTGLb9etThVvdn6paaj{position:relative;display:inline-block}.MBTRltCIO0ZXyfKTRuV0{display:inline-block;position:relative}", "",{"version":3,"sources":["webpack://./src/templates/progress/progress-bubble-set.module.scss"],"names":[],"mappings":"AAAA,sBACE,iBAAA,CACA,oBAAA,CAGF,sBACE,oBAAA,CACA,iBAAA","sourcesContent":[".main {\n  position: relative;\n  display: inline-block;\n}\n\n.withBackground {\n  display: inline-block;\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": "alTGLb9etThVvdn6paaj",
	"withBackground": "MBTRltCIO0ZXyfKTRuV0"
};
export default ___CSS_LOADER_EXPORT___;
